import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Lock, User } from 'lucide-react';
import { useAuth, formatApiError } from '../auth/AuthContext';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Button } from '../components/ui/button';
import { useToast } from '../hooks/use-toast';
import Logo from '../components/Logo';

export default function AdminLogin() {
  const { login, user } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(username, password);
      navigate('/admin');
    } catch (err) {
      toast({ title: 'Login failed', description: formatApiError(err?.response?.data?.detail, 'Invalid credentials') });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen coral-gradient flex items-center justify-center px-5">
      <div className="absolute inset-0 dotted-bg opacity-50" />
      <div className="relative w-full max-w-md bg-white rounded-3xl shadow-2xl p-8">
        <div className="flex justify-center mb-6">
          <Logo size={48} />
        </div>
        <h1 className="font-serif text-3xl font-semibold text-center">Admin Login</h1>
        <p className="text-stone-500 text-center text-sm mt-2">Sign in to manage leads & resources.</p>
        <form onSubmit={handleSubmit} className="mt-7 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="u">Username</Label>
            <div className="relative">
              <User className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
              <Input id="u" value={username} onChange={(e) => setUsername(e.target.value)} data-testid="admin-username" className="pl-9" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="p">Password</Label>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-stone-400" />
              <Input id="p" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" className="pl-9" />
            </div>
          </div>
          <Button type="submit" disabled={busy} className="w-full btn-primary border-0 h-11 font-medium">
            {busy ? 'Signing in...' : 'Sign in'}
          </Button>
        </form>
      </div>
    </div>
  );
}
